export default __webpack_public_path__ + "locales/pl/People.json?hash=87b649df27775001e5439480bc246daf";